import Reveal from "components/Reveal";
import { Link } from "react-router-dom";
import { COUNTRY_CODE } from "config/global";
import { homeData } from "config/home";

const { footer } = homeData[COUNTRY_CODE];

const Footer = () => {
  return (
    <footer className="bg-white">
      <Reveal>
        <div className="container">
          <hr className="my-8 lg:my-9" />
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start">
            <div className="w-full lg:max-w-[317px]">
              <img className="w-[104px] lg:w-[208px] mb-4" src={require("assets/logo-procold.png")} alt="Logo Procold" />
            </div>
            <div className="mb-8 lg:mb-9">
              <h6 className="text-base text-secondary font-bold">Follow Us</h6>
              <div className="flex items-center gap-3 mt-1">
                <Link
                  to={footer.instagramUrl}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="hover:scale-110 transition-all duration-300"
                >
                  <img src={require("assets/icons/social/Instagram.svg").default} alt="Instagram Icon" />
                </Link>
                <Link
                  to={footer.facebookUrl}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="hover:scale-110 transition-all duration-300"
                >
                  <img src={require("assets/icons/social/Facebook.svg").default} alt="FB Icon" />
                </Link>
              </div>
            </div>
          </div>
          <p className="my-8 lg:my-9 text-xs lg:text-base lg:text-center font-openSans text-secondary">
            © {new Date().getFullYear()} - Kalbe Consumer Health
          </p>
          <div className="lg:flex lg:items-start lg:justify-center lg:gap-8">
            <div>
              <p className="font-extrabold text-black text-[15px] leading-normal">
                Diproduksi oleh: PT KALBE FARMA Tbk.
              </p>
              <div className="flex gap-[10px] flex-wrap mt-2">
                <div className="border-2 border-black font-extrabold leading-[9px] lg:leading-[14px] text-[6.5px] lg:text-[10px] w-[104px] lg:w-[156px] h-[42px] lg:h-[62px] px-[9px] lg:px-[14px] py-[10px] text-center flex items-center justify-center">
                  BACA ATURAN PAKAI JIKA SAKIT BERLANJUT HUBUNGI DOKTER
                </div>
                <div className="border-2 border-black font-extrabold leading-[9px] lg:leading-[13px] text-[6px] lg:text-[9px] w-[104px] lg:w-[156px] h-[42px] lg:h-[62px] px-[6px] lg:px-[14px] py-[3px] lg:py-[5px] text-center flex items-center justify-center">
                  PERHATIKAN PERINGATAN DAN KONTRA INDIKASI JANGAN MELEBIHI DOSIS YANG DIANJURKAN
                </div>
                <div className="border-2 border-black font-extrabold leading-[9px] lg:leading-[14px] text-[6.5px] lg:text-[10px] w-[104px] lg:w-[156px] h-[42px] lg:h-[62px] px-[9px] lg:px-[14px] py-[10px] text-center flex items-center justify-center">
                  PROCOLD FLU DAPAT MENYEBABKAN KANTUK
                </div>
              </div>
            </div>
            <div className="pb-10 mt-3 lg:mt-0 text-black max-w-[506px]">
              <ul className="text-[9px]">
                <li>
                  Procold Flu & Batuk{" "}
                  <span>| Untuk Meringankan Gejala FLU Tidak Berdahak | Tidak menyebabkan kantuk |</span> No Reg : DTL
                  1111641504A1{" "}
                  <span className="font-bold">
                    | Paracetamol 500 mg, Dextromethorphan HBr 10 mg, Phenylephrine HCI 10 mg
                  </span>
                </li>
                <li className="mt-3">
                  Procold Flu <span className="font-bold">| Untuk Meringankan Gejala Flu | Menyebabkan kantuk |</span>{" "}
                  No Reg : DTL 1611644904A1{" "}
                  <span className="font-bold">
                    | Paracetamol 500 mg, Phenylephrine HCI 10 mg, Chlorpheniramine Maleat 2 mg
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Reveal>
    </footer>
  );
};

export default Footer;
